const link_list = {
    routePath: 'applications',
    actionName: 'count',
    iconClass: 'fa-solid fa-file',
    title: 'My Active Application',
    search: {
        status: {
            key: 'status',
            value: ["Submitted"],
        },
    },
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: '',
}
export default {link_list }